import React, { useContext, useEffect, useState } from 'react';
import { addcontext } from '../ContextShare/ContextShare';
import { searchMain } from '../Services/allApi';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import language from '../language.json'
import './searchbar.css'
function Searchbar({ searchValue, setSearchValue }) {
    const {isSearchOrAdSearch,setIsSearchOrAdSearch}=useContext(addcontext)
    const{totalSearchResultsNS,seTtotalSearchResultsNS}=useContext(addcontext)
    const {paginationStartIndex,setPaginationStartIndex}=useContext(addcontext)
    const {paginationEndIndex,setPaginationEndIndex}=useContext(addcontext)
    const [currentLanguage, setCurrentLanguage] = useState();
    const {langChanged,setlangChanged}=useContext(addcontext)
    const {searchError,setSearchError}=useContext(addcontext)

    const [placeholder, setPlaceholder] = useState('Search by KLA, Sessions, Events, Members..');
    const {isFilterOpen,setFilterOpen}=useContext(addcontext)
    const {videoData,setVideoData}=useContext(addcontext)
    const {whichPageIsSendingData,setwhichPageIsSendingData}=useContext(addcontext)
    const {videoUrl,setVideoUrl}=useContext(addcontext)
    const {videoThumb,setVideoThumb}=useContext(addcontext)
    const{filterSearchResults,setFilterSearchResults}=useContext(addcontext)
    const{InitialSearchQuery,setInitialSearchQuery}=useContext(addcontext)

    useEffect(()=>{
        setCurrentLanguage(localStorage.getItem('language')||'en')

    },[currentLanguage,langChanged])

    useEffect(() => {
        // Function to update placeholder based on screen size
        const updatePlaceholder = () => {
            if (window.innerWidth < 768) {
                setPlaceholder(currentLanguage=='en'?'Search here...':'തിരയുക...');
            } else {
                setPlaceholder(language.searchMain[currentLanguage]);
            }
        };

        // Update placeholder when component mounts
        updatePlaceholder();

        // Update placeholder when window is resized
        window.addEventListener('resize', updatePlaceholder);

        // Cleanup function to remove event listener
        return () => {
            window.removeEventListener('resize', updatePlaceholder);
        };
    }, [currentLanguage]);

    const handleInputChange = (e) => {
        setSearchValue(e.target.value);
    };

    const handleFilterBox=(e)=>{
        e.preventDefault()
        setFilterOpen(true)
        
    }
    
    const handleSearchSubmit=(e)=>{
        e.preventDefault()
        // alert(searchValue)
        if(searchValue){
            SearchApi()
        }
        else{
            toast.warning('Please enter the text to search.')
        }

    }

    const navigate=useNavigate()

    const SearchApi=(searchData)=>{
        const search_query={search_query:searchValue}
        setInitialSearchQuery(searchValue)
        // const result=await searchMain(search_query,1,10)
        // console.log(result);
        //     setFilterSearchResults(result?.data?.data)
        //     setSearchError(result?.response?.data?.message)
            setIsSearchOrAdSearch('s')
        //     console.log(result?.data?.data);
        //     seTtotalSearchResultsNS(result?.data?.count)
            setPaginationStartIndex(1)
            setPaginationEndIndex(10)
         navigate('/results')
            }

    return (
       
            <>
            <div className='search-bar flex flex-row searchbar sm:w-3/6 justify-between w-7/12' style={{ height: '40px', border: '1px solid ', borderRadius: '0.5rem' }}>
                <form className='w-10/12 ' onSubmit={(e)=>handleSearchSubmit(e)}>
                     <input type="text" placeholder={placeholder} value={searchValue} onChange={(e)=>handleInputChange(e)} id='inputbox' className={`${currentLanguage=='mal'?'custom-input':'custom-input-eng'} w-full ms-2 text-gray-300`} style={{ height: '100%', border: 'none', outline: 'none', backgroundColor: 'transparent' }} />
                     </form>
                     <div className='p-3 flex items-center justify-center bg-primary hover:bg-indigo-600 rounded-e-lg border transform duration-500 ease-in-out'style={{cursor:'pointer'}} onClick={(e)=>handleSearchSubmit(e)}><i className="fa-solid fa-magnifying-glass text-lg font-bold " ></i></div>

                {/* <div className='flex justify-end sm:w-1/12 h-full me-3 w-1/4' style={{cursor:'pointer'}} >  */}
                {/* {!isFilterOpen?<i className="fa-solid fa-sliders mt-3" onClick={e=>handleFilterBox(e)}></i>
                :
                <i class="fa-solid fa-xmark mt-3" onClick={e=>setFilterOpen(false)}></i>
                } */}
                {/* </div> */}
            </div>

                <div><button onClick={e=>handleFilterBox(e)} className={`${currentLanguage=='mal'&&'text-xs'} p-2 hover:bg-indigo-600 rounded-lg ms-2 border transform duration-500 ease-in-out`} style={{height:'40px'}}>{language.advanced_search[currentLanguage]}</button></div>
            </>


    );
}

export default Searchbar;
